module.exports = __webpack_public_path__ + "static/media/boost-your-post-for-increasing-sales.7c33af2f.md";